<template>
  <div>
    <div class="filter-container" v-if="showQuery">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="16">
          <span class="span-top-text">搜索</span>
          <div class="searchIcon" @click="showForm = !showForm">
            <i :class="showForm ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="btn-search">
            <el-button type="primary" icon="el-icon-search" @click="query()">搜索</el-button>
            <el-button type="primary" plain @click="resetQuery">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="showForm">
        <el-divider style="margin: 0px"></el-divider>
        <el-form class="form-item" :label-width="labelWidth" @keyup.enter.native="query()">
          <slot name="query"></slot>
        </el-form>
      </el-row>
    </div>
    <div v-if="showToolbar" v-show="data.length" class="filter-container" style="margin-bottom: 0">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="6">
          <slot name="toolbar-left">
            <span v-if="showQuery" class="span-top-text">列表</span>
            <span v-if="searchTitle" class="span-top-text">- {{ searchTitle }}</span>
          </slot>
        </el-col>
        <el-col :span="18">
          <div style="text-align: right">
            <slot name="toolbar-right"></slot>
          </div>
        </el-col>
      </el-row>
    </div>
    <slot name="list">
      <div v-if="centerTitle&&data&&data.length" class="centerTitle">{{ centerTitle }}</div>
      <div v-for="(item, index) in data" :key="index" class="list_box">
        <template v-if="isMerge">
          <div v-if="layout.length">
            <el-row :gutter="20">
              <template v-for="item2 in layout">
                <el-col v-if="item2.isMain" :span="item2.span">
                  <span class="bold1">{{ item2.name }}：</span>
                  <span class="content1">{{ item[item2.key] }}</span>
                </el-col>
              </template>
            </el-row>
          </div>
          <div class="item_box" v-for="(item3, index3) in item[itemName]" :key="index3">
            <el-row :gutter="20">
              <template v-for="item4 in layout">
                <el-col v-if="!item4.isMain" :span="item4.span">
                  <span class="bold2">{{ item4.name }}：</span>
                  <span class="content2" v-if="item4.isDate">{{ $commonJs.toDateString(item3[item4.key]) }}</span>
                  <span class="content2" v-else>{{ item3[item4.key] }}</span>
                </el-col>
              </template>
            </el-row>
            <el-table
              :data="item3[itemName2]"
              :size="size"
              :max-height="maxHeight"
              :show-summary="showSummary"
              :summary-method="summaryMethod"
              :highlight-current-row="lightRow"
              :row-key="rowKey"
              :stripe="showStripe"
              :border="border"
              :loading="loading"
              class="tb-head-color parent-table"
              style="width: 100%"
              :row-style="{ height: '40px' }"
              :cell-style="{ padding: '0px' }"
              @expand-change="expandChange"
            >
              <slot name="table"></slot>
              <slot name="column"></slot>
            </el-table>
          </div>
        </template>
        <template v-else>
          <div v-if="layout.length">
            <el-row :gutter="20">
              <el-col v-for="(item2, index) in layout" :key="index" :span="item2.span">
                <span class="bold3" v-if="item2.name">{{ item2.name }}：</span>
                <span class="content3" v-if="item2.isDate">{{ $commonJs.toDateString(item[item2.key]) }}</span>
                <span class="content3" v-else>{{ item[item2.key] }}</span>
              </el-col>
            </el-row>
          </div>
          <el-table
            :data="item[itemName]"
            :size="size"
            :max-height="maxHeight"
            :show-summary="showSummary"
            :summary-method="summaryMethod"
            :highlight-current-row="lightRow"
            :row-key="rowKey"
            :stripe="showStripe"
            :border="border"
            :loading="loading"
            class="tb-head-color parent-table"
            style="width: 100%"
            :row-style="{ height: '40px' }"
            :cell-style="{ padding: '0px' }"
            @expand-change="expandChange"
          >
            <!-- slot[column] -->
            <slot name="table">
              <template v-if="item.Name == '物料成本'">
                <el-table-column prop="" label="产品名称" min-width="120px" />
                <el-table-column prop="" label="原材料/配件名称" min-width="120px" />
                <el-table-column prop="" label="条码" min-width="120px" />
                <el-table-column prop="" label="耗用数量" />
                <el-table-column prop="" label="单位" min-width="120px" />
                <el-table-column prop="" label="单价" />
                <el-table-column prop="" label="金额"
              /></template>
              <template v-else-if="item.Name == '人工成本'">
                <el-table-column prop="" label="加工阶段" min-width="120px" />
                <el-table-column prop="" label="产品/半成品名称" min-width="120px" />
                <el-table-column prop="" label="条码" />
                <el-table-column prop="" label="加工人员" min-width="120px" />
                <el-table-column prop="" label="加工数量" />
                <el-table-column prop="" label="单位" />
                <el-table-column prop="" label="单价" />
                <el-table-column prop="" label="金额"
              /></template>
            </slot>
            <slot name="column"></slot>
            <!--/ slot[column]-->
          </el-table>
        </template>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    labelWidth: {
      type: String,
      default: '96px'
    },
    lightRow: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: String,
      default: undefined
    },
    showStripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String,
      default: '-'
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    summaryMethod: {
      type: Function
    },
    showQuery: {
      type: Boolean,
      default: false
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'medium'
    },
    queryParams: {
      type: Object,
      defalut: () => ({})
    },
    getDataFunc: {
      type: Function,
      default: null
    },
    itemName: {
      type: String,
      default: 'items'
    },
    itemName2: {
      type: String,
      default: 'items'
    },
    layout: {
      type: Array,
      default: () => []
    },
    isMerge: {
      type: Boolean,
      default: false
    },
    searchTitle: {
      type: String,
      default: ''
    },
    centerTitle: {
      type: String,
      default: ''
    }
  },
  watch: {
    isMerge() {
      this.data = []
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      showForm: true,
      initParams: {},
      //查询参数
      tempQueryParams: {},
      initQueryParams: {}
    }
  },
  mounted() {
    this.initQueryParams = { ...this.queryParams }
    this.tempQueryParams = { ...this.queryParams }
  },
  methods: {
    expandChange(row, expandedRows) {
      this.$emit('expand-change', { currentRow: row, expandedRows })
    },
    //查询方法
    query(params = null) {
      if (params != null) {
        for (let key in params) {
          this.queryParams[key] = params[key]
        }
      }
      this.tempQueryParams = { ...this.queryParams }
      console.log('tempQueryParams', this.tempQueryParams)
      return this.getData()
    },
    //重置查询条件
    resetQuery() {
      for (let key in this.queryParams) {
        this.queryParams[key] = this.initQueryParams[key]
      }
      this.$emit('reset')
    },
    getData(initParams = null) {
      if (initParams != null) {
        this.clear()
        this.initParams = { ...initParams }
        return this.resetQuery()
      }
      let params = {}
      console.log('this.initParams', this.initParams)
      console.log('this.tempQueryParams', this.tempQueryParams)

      params = {
        ...params,
        ...this.initParams,
        ...this.tempQueryParams
      }
      console.log('params', params)
      params = this.$commonJs.obj.removeNullKey(params)
      this.loading = true

      let getDataFunc = null
      if (this.getDataFunc) {
        getDataFunc = this.getDataFunc
      } else {
        alert('请指定list组件里get-data-func属性！')
        return false
      }

      return new Promise((resolve, reject) => {
        getDataFunc(params)
          .then(res => {
            if (res.Code != 401) {
              if (res.Data instanceof Array) {
                console.log(res.Data, 'res.Data')
                this.data = res.Data
                this.$emit('getDataEnd', this.data)
                if (!res.Data.length) this.$message({ message: '暂无符合条件的数据', type: 'warning' })
              } else {
                this.data = [];
                alert('找不到数据列表');
              }
            }
            this.loading = false
            resolve({ list: this.data })
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    reload() {
      // return this.getData();
    },
    clear() {
      this.data = []
    }
  }
}
</script>
<style lang="scss">
.searchIcon {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #aaa;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  margin-left: 4px;

  i {
    transition-duration: 0.2s;
  }
  .el-icon-arrow-down {
    vertical-align: -1px;
  }
}
</style>
<style scoped>
.list_box {
  padding: 6px 12px 10px;
  border: 1px solid #eee;
  border-top: none;
}
.item_box {
  padding: 0px 10px 10px;
  border: 1px solid #eee;
  margin-bottom: 10px;
}
.bold1 {
  font-size: 14px;
  font-weight: bold;
  line-height: 40px;
}
.content1 {
  font-size: 14px;
  line-height: 40px;
}
.bold2 {
  font-size: 14px;
  font-weight: bold;
  line-height: 35px;
}
.content2 {
  font-size: 14px;
  line-height: 35px;
}
.bold3 {
  font-size: 14px;
  font-weight: bold;
  line-height: 26px;
}
.content3 {
  font-size: 14px;
  line-height: 26px;
}
.centerTitle {
  font-weight: bold;
  text-align: center;
  font-size: 22px;
  padding-top: 10px;
  letter-spacing: 2px;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
</style>